import React from 'react';
import { Typography, Card, Button, Space, Descriptions, Tag } from 'antd';
import { EditOutlined, HistoryOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';

const { Title, Text } = Typography;

const COGSDetailPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  return (
    <div>
      <div style={{ marginBottom: '24px' }}>
        <Space>
          <Button 
            icon={<ArrowLeftOutlined />} 
            onClick={() => navigate('/')}
          >
            Back to Home
          </Button>
        </Space>
      </div>

      <div style={{ marginBottom: '24px' }}>
        <Title level={2}>COGS Rule Details</Title>
        <Text type="secondary">
          Viewing details for COGS Rule ID: {id}
        </Text>
      </div>

      <Card
        title="Rule Information"
        extra={
          <Space>
            <Button icon={<HistoryOutlined />}>View History</Button>
            <Button type="primary" icon={<EditOutlined />}>
              Edit Rule
            </Button>
          </Space>
        }
      >
        <Descriptions bordered column={2}>
          <Descriptions.Item label="Status">
            <Tag color="green">APPROVED</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Entity">
            Instamoney
          </Descriptions.Item>
          <Descriptions.Item label="Product">
            Virtual Account
          </Descriptions.Item>
          <Descriptions.Item label="Channel">
            BNI
          </Descriptions.Item>
          <Descriptions.Item label="Pricing Scheme">
            MDR + Fixed
          </Descriptions.Item>
          <Descriptions.Item label="Currency">
            IDR
          </Descriptions.Item>
          <Descriptions.Item label="Flat Fee">
            Rp 2,500
          </Descriptions.Item>
          <Descriptions.Item label="Percentage Rate">
            1.5%
          </Descriptions.Item>
          <Descriptions.Item label="Minimum Fee">
            Rp 1,000
          </Descriptions.Item>
          <Descriptions.Item label="Maximum Fee">
            Rp 50,000
          </Descriptions.Item>
          <Descriptions.Item label="Effective Date">
            2024-01-01
          </Descriptions.Item>
          <Descriptions.Item label="Proposer">
            John Doe
          </Descriptions.Item>
        </Descriptions>

        <div style={{ marginTop: '24px', textAlign: 'center' }}>
          <Text type="secondary">
            Detailed COGS rule view will be fully implemented here.
            <br />
            This will include all rule details, history, and edit capabilities.
          </Text>
        </div>
      </Card>
    </div>
  );
};

export default COGSDetailPage;
